<div class="text-center mb-3 pr-5 pl-5">
  <span class="material-icons display-2">forward_to_inbox</span>
</div>
<div class="text-center">
  <h1 mat-dialog-title>Wysłanie wiadomości...</h1>
</div>
